import { type SvgProps, SvgWrapper } from '../utils';

export function ChevronDownIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M17.4697 8.46967C17.7626 8.17678 18.2374 8.17678 18.5303 8.46967C18.8232 8.76256 18.8232 9.23732 18.5303 9.53022L12.5303 15.5302C12.2374 15.8231 11.7626 15.8231 11.4697 15.5302L5.46972 9.53022C5.17683 9.23732 5.17683 8.76256 5.46972 8.46967C5.76262 8.17678 6.23738 8.17678 6.53027 8.46967L12 13.9394L17.4697 8.46967Z" />
    </SvgWrapper>
  );
}
